var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.commentHighlights.length
        ? _c(
            "job-preview-comments",
            _vm._g(
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.highlightMode,
                    expression: "highlightMode",
                  },
                ],
                class: _vm.commentClass,
                attrs: { comments: _vm.commentHighlights },
              },
              _vm.$listeners
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.textCountMode && _vm.textCountsNotNull.length
        ? _c(
            "div",
            {
              staticClass: "pega-text-count-area",
              class: _vm.textCountClass,
              attrs: { "data-test": "text-count-area" },
            },
            _vm._l(_vm.textCountsNotNull, function (textCount) {
              return _c("text-count", {
                key: textCount.name,
                attrs: {
                  name: textCount.name,
                  "count-target": textCount.value,
                  max: textCount.max,
                  tooltip: textCount.tooltip,
                  margin: textCount.margin,
                },
              })
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }